
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-2ba6a624!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./modifyHomePage.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./modifyHomePage.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-2ba6a624!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./modifyHomePage.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/homePage/modifyHomePage.vue
// module id = 993
// module chunks = 2